import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Paper, Typography } from '@mui/material';

ChartJS.register(ArcElement, Tooltip, Legend);

interface DashboardChartProps {
  title: string;
  fontFamily?: string;
  data: {
    labels: string[];
    datasets: {
      data: number[];
      backgroundColor: string[];
      borderColor: string[];
      borderWidth: number;
    }[];
  };
}

export const DashboardChart: React.FC<DashboardChartProps> = ({ title, data, fontFamily = 'JetBrains Mono' }) => {
  return (
    <Paper elevation={3} sx={{ p: 2, height: '100%', fontFamily }}>
      <Typography variant="h6" gutterBottom sx={{ fontFamily }}>
        {title}
      </Typography>
      <div style={{ height: '280px', position: 'relative' }}>
        <Pie
          data={data}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'bottom',
                labels: {
                  font: {
                    family: fontFamily,
                    size: 12
                  },
                  boxWidth: 12,
                  padding: 10
                }
              }
            }
          }}
        />
      </div>
    </Paper>
  );
}; 